// MOCK DATA for FesMed EMS — frontend-only preview.
// Replace with backend API data during full-stack integration.

export const LOGO = '/assets/fesmed-logo.jpg';

export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Shop', path: '/shop' },
  { label: 'Services', path: '/services' },
  { label: 'Training', path: '/training' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

export const CATEGORIES = [
  {
    id: 'first-aid-kits',
    name: 'First Aid Kits',
    tagline: 'IFAK, trauma, workplace & remote kits',
    image: 'https://images.pexels.com/photos/8388915/pexels-photo-8388915.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    sub: ['Tactical / IFAK', 'Bleeding Control', 'Trauma Kits', 'Workplace', 'Outdoor / Remote', 'Vehicle'],
  },
  {
    id: 'medical-supplies',
    name: 'Medical Supplies',
    tagline: 'Tourniquets, dressings, airway & PPE',
    image: 'https://tacmedaustralia.com.au/cdn/shop/products/fcp-01.jpg?v=1753927664&width=1080',
    sub: ['Tourniquets', 'Wound Dressings', 'Airway & Breathing', 'Diagnostics', 'PPE', 'Hypothermia'],
  },
  {
    id: 'bags-pouches',
    name: 'Bags & Pouches',
    tagline: 'Paramedic, tactical & SAR carry solutions',
    image: 'https://images.unsplash.com/photo-1778495351229-0ce0a1963fab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000',
    sub: ['Tactical / IFAK', 'Ambulance', 'Search & Rescue', 'Gear Bags', 'First Aid'],
  },
  {
    id: 'hardware',
    name: 'Hardware & AEDs',
    tagline: 'Stretchers, splints, shears & defibrillators',
    image: 'https://images.pexels.com/photos/11655091/pexels-photo-11655091.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    sub: ['Stretchers & Litters', 'Splints', 'Trauma Shears', 'AEDs', 'Torches & Lighting'],
  },
];

export const PRODUCTS = [
  {
    id: 'sof-tourniquet',
    name: 'SOF\u00ae Tourniquet Wide',
    price: 66.95,
    category: 'medical-supplies',
    subcategory: 'Tourniquets',
    rating: 4.9,
    reviews: 231,
    badge: 'Best Seller',
    image: 'https://tacmedaustralia.com.au/cdn/shop/products/sof-tgen5red.jpg?v=1764816465&width=1000',
    short: 'One-handed, high-visibility windlass tourniquet for rapid hemorrhage control.',
    desc: 'The SOF Tactical Tourniquet Wide delivers fast, effective bleeding control with a 1.5" wide strap and aluminium windlass. Trusted by military and EMS worldwide.',
  },
  {
    id: 'cat-gen7',
    name: 'C.A.T Tourniquet Gen 7',
    price: 67.95,
    category: 'medical-supplies',
    subcategory: 'Tourniquets',
    rating: 4.9,
    reviews: 188,
    badge: 'Best Seller',
    image: 'https://tacmedaustralia.com.au/cdn/shop/products/CAT_Gen_7_-_Black.jpg?v=1748393480&width=1000',
    short: 'The gold-standard combat application tourniquet, now in Gen 7.',
    desc: 'The Combat Application Tourniquet (C.A.T) Gen 7 features a single routing buckle for fast one-handed application and reinforced windlass clip.',
  },
  {
    id: 'israeli-bandage',
    name: 'Emergency Bandage (Israeli Bandage)',
    price: 21.95,
    category: 'medical-supplies',
    subcategory: 'Wound Dressings',
    rating: 4.8,
    reviews: 71,
    image: 'https://tacmedaustralia.com.au/cdn/shop/products/fcp-01.jpg?v=1753927664&width=1080',
    short: 'All-in-one pressure dressing with built-in pressure bar.',
    desc: 'The Emergency Bandage consolidates multiple first-aid devices into a single sterile unit for controlling severe bleeding in emergency situations.',
  },
  {
    id: 'olaes-dressing',
    name: 'OLAES Modular Trauma Dressing',
    price: 19.95,
    category: 'medical-supplies',
    subcategory: 'Wound Dressings',
    rating: 4.8,
    reviews: 66,
    image: 'https://tacmedaustralia.com.au/cdn/shop/files/OLAES_1.png?v=1776653735&width=1080',
    short: 'Modular dressing with gauze, occlusive layer & pressure cup.',
    desc: 'The OLAES Modular Bandage integrates 3m of gauze, a removable occlusive layer, and a pressure cup for versatile wound management.',
  },
  {
    id: 'snake-bite-bandage',
    name: 'Premium Snake Bite Bandage with Indicator',
    price: 9.95,
    category: 'medical-supplies',
    subcategory: 'Wound Dressings',
    rating: 4.9,
    reviews: 100,
    image: 'https://tacmedaustralia.com.au/cdn/shop/products/AFHSB100-unstretched.jpg?v=1753927673&width=1080',
    short: 'Tension-indicator bandage for correct pressure immobilisation.',
    desc: 'Printed tension indicators ensure the correct pressure is applied during snakebite first aid \u2014 essential for the Australian outdoors.',
  },
  {
    id: 'npa-airway',
    name: 'Nasopharyngeal Airway (NPA)',
    price: 10.70,
    category: 'medical-supplies',
    subcategory: 'Airway & Breathing',
    rating: 4.7,
    reviews: 42,
    image: 'https://tacmedaustralia.com.au/cdn/shop/files/Screenshot_2024-09-12_130748.png?v=1726110505&width=800',
    short: 'Flexible airway adjunct with flared safety tip.',
    desc: 'Maintains a clear airway in unconscious or semi-conscious patients. Supplied with lubricant sachet.',
  },
  {
    id: 'trauma-shears',
    name: 'NAR Trauma Shears',
    price: 15.00,
    oldPrice: 27.40,
    category: 'hardware',
    subcategory: 'Trauma Shears',
    rating: 4.8,
    reviews: 58,
    badge: 'Sale',
    image: 'https://tacmedaustralia.com.au/cdn/shop/files/trauma_shears_size_6_1_4.jpg?v=1781477576&width=800',
    short: 'Heavy-duty shears that cut through denim, leather & seatbelts.',
    desc: 'Serrated, fluoride-coated blades slice through the toughest materials to expose wounds quickly.',
  },
  {
    id: 'wallet-cards',
    name: 'FesMed Wallet Reference Cards',
    price: 5.95,
    category: 'hardware',
    subcategory: 'Books & Cards',
    rating: 4.9,
    reviews: 110,
    image: 'https://tacmedaustralia.com.au/cdn/shop/files/walletrefcards.png?v=1776654001&width=1080',
    short: 'Pocket vital-signs, GCS & triage reference cards.',
    desc: 'Waterproof wallet cards with adult/paediatric vital signs, Glasgow Coma Scale and triage sieve for rapid field reference.',
  },
  {
    id: 'ifak-pro-kit',
    name: 'FesMed IFAK Pro Trauma Kit',
    price: 189.95,
    category: 'first-aid-kits',
    subcategory: 'Tactical / IFAK',
    rating: 5.0,
    reviews: 47,
    badge: 'New',
    image: 'https://images.unsplash.com/photo-1778495351229-0ce0a1963fab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000',
    short: 'Complete individual first aid kit for the frontline responder.',
    desc: 'A rugged laser-cut MOLLE pouch loaded with tourniquet, hemostatic gauze, chest seals, NPA and trauma dressing \u2014 everything to treat life-threatening bleeding.',
  },
  {
    id: 'trauma-backpack',
    name: 'Responder Trauma Backpack',
    price: 349.95,
    category: 'bags-pouches',
    subcategory: 'Gear Bags',
    rating: 4.9,
    reviews: 33,
    badge: 'New',
    image: 'https://images.unsplash.com/photo-1579037005241-a79202c7e9fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000',
    short: 'Modular paramedic pack with colour-coded internal pouches.',
    desc: 'Purpose-built for pre-hospital response with quick-access airway, circulation and drug modules. Water-resistant 1000D construction.',
  },
  {
    id: 'bleeding-station',
    name: 'Public Bleeding Control Station',
    price: 299.95,
    category: 'first-aid-kits',
    subcategory: 'Bleeding Control',
    rating: 4.8,
    reviews: 21,
    image: 'https://images.pexels.com/photos/8388915/pexels-photo-8388915.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    short: 'Wall-mounted station equipping bystanders to stop the bleed.',
    desc: 'Contains multiple tourniquets, hemostatic dressings, chest seals and instructions \u2014 place in workplaces, schools and public venues.',
  },
  {
    id: 'aed-defib',
    name: 'Public Access AED Defibrillator',
    price: 1899.00,
    category: 'hardware',
    subcategory: 'AEDs',
    rating: 5.0,
    reviews: 18,
    image: 'https://images.pexels.com/photos/11655091/pexels-photo-11655091.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    short: 'Fully automatic AED with clear voice & visual prompts.',
    desc: 'Rescue-ready defibrillator with real-time CPR feedback, 8-year warranty and IP55 dust/water rating for any environment.',
  },
];

export const SERVICES = [
  {
    id: 'event-medical',
    title: 'Event Medical',
    image: 'https://images.unsplash.com/photo-1722974180453-305758503804?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    desc: 'High-quality medical care for your event, delivered by highly qualified medics \u2014 ensuring safety without compromising on quality.',
  },
  {
    id: 'high-risk-sport',
    title: 'High Risk Sporting Events',
    image: 'https://images.pexels.com/photos/17979595/pexels-photo-17979595.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    desc: 'We ensure the safety of competitors and spectators no matter the sport, with advanced equipment and skilled medics.',
  },
  {
    id: 'patient-transport',
    title: 'Patient Transport Services',
    image: 'https://images.pexels.com/photos/8942043/pexels-photo-8942043.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    desc: 'Safe, comfortable non-emergency and inter-facility patient transport, staffed by qualified medics with fully equipped vehicles.',
  },
  {
    id: 'remote-area',
    title: 'Remote Area Medics',
    image: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    desc: 'High-quality medical personnel for Australia\u2019s most remote areas, equipped to operate internationally for disaster assistance.',
  },
  {
    id: 'schools',
    title: 'Event Medical for Schools',
    image: 'https://images.pexels.com/photos/6519905/pexels-photo-6519905.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    desc: 'Skilled medics with valid WWCC, trained in the assessment and care of children \u2014 perfect for your school\u2019s next sports day.',
  },
  {
    id: 'industrial',
    title: 'Industrial Medics & MESOs',
    image: 'https://images.pexels.com/photos/8388915/pexels-photo-8388915.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    desc: 'Specialised emergency response solutions for industrial sites across Australia, with capacity for ultra-remote operations.',
  },
  {
    id: 'mobile-dialysis',
    title: 'Mobile Dialysis Services',
    image: 'https://images.pexels.com/photos/8942043/pexels-photo-8942043.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    desc: 'On-site and at-home dialysis delivered by specialist renal nurses, bringing reliable treatment closer to the patients who need it.',
  },
];

export const COURSES = [
  {
    id: 'provide-first-aid',
    code: 'HLTAID011',
    title: 'Provide First Aid',
    duration: '1 Day',
    price: 145,
    level: 'Entry',
    image: 'https://images.pexels.com/photos/6519905/pexels-photo-6519905.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    desc: 'Nationally recognised first aid certification covering CPR, wound care and emergency response for the workplace.',
  },
  {
    id: 'cpr',
    code: 'HLTAID009',
    title: 'Provide CPR',
    duration: '3 Hours',
    price: 75,
    level: 'Entry',
    image: 'https://images.pexels.com/photos/11655091/pexels-photo-11655091.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    desc: 'Learn to perform cardiopulmonary resuscitation and operate an AED in line with ARC guidelines.',
  },
  {
    id: 'stop-the-bleed',
    code: 'STB',
    title: 'Stop the Bleed',
    duration: '2.5 Hours',
    price: 89,
    level: 'Entry',
    image: 'https://tacmedaustralia.com.au/cdn/shop/products/sof-tgen5red.jpg?v=1764816465&width=1000',
    desc: 'Empower bystanders to control life-threatening bleeding with tourniquets, wound packing and direct pressure.',
  },
  {
    id: 'remote-first-aid',
    code: 'HLTAID013',
    title: 'Remote Area First Aid',
    duration: '2 Days',
    price: 320,
    level: 'Intermediate',
    image: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000',
    desc: 'Extended first aid skills for isolated environments where help may be hours or days away.',
  },
  {
    id: 'phtls',
    code: 'PHTLS',
    title: 'Pre-Hospital Trauma Life Support',
    duration: '2 Days',
    price: 795,
    level: 'Advanced',
    image: 'https://images.pexels.com/photos/8942043/pexels-photo-8942043.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    desc: 'Internationally recognised trauma course for paramedics, nurses and doctors managing critically injured patients.',
  },
];

export const STATS = [
  { value: '15+', label: 'Years Experience' },
  { value: '2,500+', label: 'Events Covered' },
  { value: '50k+', label: 'Products Shipped' },
  { value: '100%', label: 'Qualified Medics' },
];

export const INDUSTRIES = [
  'Law Enforcement', 'Health Professionals', 'Ambulance', 'Fire & Rescue', 'Mining', 'Outdoor Recreation', 'Workplace', 'Schools',
];

export const TESTIMONIALS = [
  { name: 'Sarah M.', role: 'Event Organiser', text: 'FesMed EMS covered our 3-day festival flawlessly. Professional, discreet and incredibly well equipped.', rating: 5 },
  { name: 'Cpl. James R.', role: 'Defence', text: 'The IFAK kits are field-proven. Quality gear that I trust when it matters most.', rating: 5 },
  { name: 'Dr. Lena T.', role: 'GP & Trainer', text: 'Their trauma training is second to none \u2014 hands-on, realistic and delivered by real medics.', rating: 5 },
];

export const CONTACT_INFO = {
  phone: '+61 478 886 027',
  email: 'operations@fesmed-ems.com',
  address: 'Nationwide',
  hours: 'Mon\u2013Fri 8:00am \u2013 6:00pm',
};
